import axios from "axios";
import { SERVER } from "./SERVER";
import { TIMEOUT } from "./TIMEOUT";

class QuoteDataService {
    getAll(token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/quotes/`, { timeout: TIMEOUT });
    }
    getNextQuoteNumber(token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/next/quote/`, { timeout: TIMEOUT });
    }
    createQuote(data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.post(`${SERVER}/api/create/quote/`, data);
    }
    updateQuote(id, data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.put(`${SERVER}/api/quote/${id}`, data);
    }
    deleteQuote(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.delete(`${SERVER}/api/quote/${id}`);
    }
    searchAll(token, search) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/quotes/search/lookup/?name=${search}`);
    }
}

export default new QuoteDataService();
